import axiosClient from "./axiosClient";
import {Result} from "./types";
import {getTokenCookie} from "libs";

export class SettingApi {
    config: any

    constructor() {
        const token = getTokenCookie()
        this.config = {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }
    }

    getSetting = async (): Promise<Result> => {
        return await axiosClient.get(`/setting/view`, this.config)
    }

    postUpdateSetting = async (data: any): Promise<Result> => {
        return await axiosClient.post(`/setting/update`, data, this.config);
    }
}
